module.exports = __webpack_public_path__ + "static/media/treasure-finding-app.5dc1db83.png";